import { render, staticRenderFns } from "./DiasPendientes.vue?vue&type=template&id=5e47029b&"
import script from "./DiasPendientes.vue?vue&type=script&lang=js&"
export * from "./DiasPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports